import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';
var ExitWarningModalContext = /*#__PURE__*/createContext({
  getShouldShowWarning: function getShouldShowWarning() {
    return false;
  },
  setShouldShowWarning: function setShouldShowWarning() {},
  showExitWarning: false,
  setShowExitWarning: function setShowExitWarning() {
    return false;
  },
  withExitWarning: function withExitWarning() {
    return function () {
      return false;
    };
  }
});
export var ExitWarningModalProvider = function ExitWarningModalProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showExitWarning = _useState2[0],
    setShowExitWarning = _useState2[1];
  var shouldShowWarning = useRef(false);
  var getShouldShowWarning = useCallback(function () {
    return shouldShowWarning.current;
  }, []);
  var setShouldShowWarning = useCallback(function (show) {
    shouldShowWarning.current = show;
  }, []);
  var withExitWarning = useCallback(function (callback) {
    return function () {
      if (shouldShowWarning.current && !showExitWarning) {
        setShowExitWarning(true);
        return false;
      }
      setShowExitWarning(false);
      callback === null || callback === void 0 || callback(true);
      return true;
    };
  }, [showExitWarning]);
  var value = useMemo(function () {
    return {
      getShouldShowWarning: getShouldShowWarning,
      setShouldShowWarning: setShouldShowWarning,
      showExitWarning: showExitWarning,
      setShowExitWarning: setShowExitWarning,
      withExitWarning: withExitWarning
    };
  }, [getShouldShowWarning, setShouldShowWarning, showExitWarning, setShowExitWarning, withExitWarning]);
  return /*#__PURE__*/React.createElement(ExitWarningModalContext.Provider, {
    value: value
  }, children);
};
export var useExitWarningModal = function useExitWarningModal() {
  var value = useContext(ExitWarningModalContext);
  if (!value) {
    throw new Error('useExitWarningModal used outside of ExitWarningModalProvider');
  }
  return value;
};
export var useWithExitWarning = function useWithExitWarning() {
  var value = useContext(ExitWarningModalContext);
  if (!value) {
    throw new Error('useWithExitWarning used outside of ExitWarningModalProvider');
  }
  var withExitWarning = value.withExitWarning;
  return withExitWarning;
};